import { Link, useLocation } from "react-router-dom";
import * as Icons from "lucide-react";

// Firestore collections each Command Centre section reads/writes.
const SECTION_COLLECTIONS = {
  "/": ["requests", "lead_distributions", "projects", "professionals", "users", "payments", "disputes", "activity_logs"],
  "/system": ["system_status", "legal_documents"],
  "/data": ["all collections"],
  "/activity": ["activity_logs"],
  "/customers": ["users", "customers", "customer_addresses", "requests", "projects", "payments", "account_suspensions", "suspension_notices"],
  "/professionals": ["professionals", "pro_logins", "account_suspensions", "activity_logs"],
  "/requests": ["lead_settings", "requests", "requests/{id}/private", "lead_distributions", "professional_responses", "request_requirements", "professionals", "users", "categories", "projects"],
  "/projects": ["projects", "project_milestones", "milestone_plans", "project_delays", "supervisor_visits", "requests", "users", "professionals"],
  "/visits": ["supervisor_visits", "project_milestones", "projects", "users"],
  "/performance": ["professionals", "lead_distributions", "projects", "consultations"],
  "/incentives": ["professionals"],
  "/crm": ["milestone_plans", "project_milestones", "supervisor_visits", "project_delays", "projects", "requests", "users", "professionals"],
  "/care": ["support_conversations", "support_tickets", "critical_notifications", "chat_threads", "chat_messages", "supervisor_visits", "disputes"],
  "/orders": ["orders", "customer_material_lists", "users"],
  "/promise": ["promise_requests", "requests", "projects"],
  "/notifications": ["requests", "orders", "promise_requests", "support_conversations", "support_tickets", "supervisor_visits", "chat_threads", "pro_signups", "professionals", "projects", "project_milestones", "milestone_plans", "critical_notifications", "razorpay_payments", "wallet_payments"],
  "/payments": ["razorpay_payments", "project_milestones", "customer_payments", "customer_payments/{id}/transactions", "wallet_holds", "wallet_payments", "cc_payment_records", "payments", "payment_settings", "system_status"],
  "/coupons": ["coupons", "coupon_redemptions", "coupon_grants", "product_collections", "razorpay_payments", "products", "categories"],
  "/catalog": ["categories", "products", "product_categories", "professional_categories", "shop_settings", "activity_logs"],
  "/invoices": ["invoices", "invoice_settings", "invoice_counters", "razorpay_payments", "wallet_payments", "orders", "promise_requests", "project_milestones"],
  "/content": ["site_content", "config", "system_status", "cms_versions"],
  "/deployments": ["requests", "lead_distributions", "professionals"],
  "/analytics": ["activity_logs", "requests", "projects", "professionals"],
  "/field/new-professional": ["professionals", "categories", "activity_logs"],
};

export function CollectionChips() {
  const { pathname } = useLocation();
  const list = SECTION_COLLECTIONS[pathname];
  if (!list) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5" data-testid="section-collections">
      <Icons.Database className="h-3.5 w-3.5 text-muted-foreground" />
      <span className="text-[11px] text-muted-foreground">Firestore:</span>
      {list.map((c) => (c.includes("{") || c === "all collections"
        ? <span key={c} className="text-[11px] font-mono rounded-md border border-border bg-secondary/60 px-1.5 py-0.5">{c}</span>
        : <Link key={c} to={`/data?path=${c}`} className="text-[11px] font-mono rounded-md border border-border bg-secondary/60 px-1.5 py-0.5 hover:border-primary hover:text-primary transition-colors" data-testid={`section-coll-${c}`}>{c}</Link>))}
    </div>
  );
}
